module.exports = __webpack_public_path__ + "img/1524609222.9d0ec2d3.jpg";